import { RuleType } from '@cox/core-ui8/dist/types'

import ComponentTypeRenderer from '../../../../config/component-type-renderer'
import { AEM_CONSTANTS } from '../../../../constants'

const RuleResultsRenderer = (props: {
  ruleId: string
  results: any
  condition?: string
  ruleType?: RuleType
  ruleExpression?: string
  index?: number
  isInEditor?: boolean
  componentTypeRenderer?: any
}) => {
  const { ruleId, results, condition, ruleType, ruleExpression, index, isInEditor = false } = props
  try {
    if (results && Object.keys(results).length > 0) {
      return results?.[AEM_CONSTANTS.ITEMS_ORDER_PROP]?.map((item: string | number, itemIndex: number) => {
        return results?.[AEM_CONSTANTS.ITEMS_PROP]?.[item]?.[AEM_CONSTANTS.ITEMS_ORDER_PROP]?.map(
          (subItem: string | number, subIndex: number) => {
            return (
              <ComponentTypeRenderer
                key={itemIndex - subIndex}
                componentType={results?.[AEM_CONSTANTS.ITEMS_PROP]?.[item]?.[AEM_CONSTANTS.ITEMS_PROP]?.[subItem]?.[':type']}
                componentProps={results?.[AEM_CONSTANTS.ITEMS_PROP]?.[item]?.[AEM_CONSTANTS.ITEMS_PROP]?.[subItem]}
                condition={condition}
                ruleExpression={ruleExpression}
                ruleType={ruleType}
                ruleId={ruleId}
                index={index}
              />
            )
          }
        )
      })
    }
    return <></>
  } catch (err) {
    console.error('err', err)
    if (isInEditor) {
      return (
        <div className='editor-text' data-testid={ruleId}>
          Check Rules Configuration
        </div>
      )
    }
  }
}

export default RuleResultsRenderer
